import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React from 'react';
import {SingleSource,WorkItems} from '../utility';
import WorkFooter from '../components/workfooter';
import Context from '../components/context';

export default function WorkPage() {
    const workItem = WorkItems();

    return (
        <>
            <Container className='pt-5 mt-5 work'>
                <div className='subTitle text-start'>AI-Powered Geospatial Planning Tool</div>
                <div className="d-flex align-items-center py-3">
                    <h1 className='mainTitle text-start'>{workItem.title}</h1>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/title.jpg`}/>
                </div>
                <Row className="d-flex align-items-center">
                    <Col lg='2'>
                        <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/summary.jpg`}/>
                    </Col>
                    <Col>
                        <div className='mainDes text-start'>
                            The legacy tool was a geospatial application used to assess and document wetland characteristics for conservation planning and compliance.
                            <span className='workBold'> Our mission was to integrate it into the USDA's primary web-based platform and enhance functionality.</span>
                        </div>
                    </Col>
                </Row>
                <Row className='py-5 text-start'>
                    <Col lg='3' sm='12' className='py-3'>
                        <div className='workBold2'>
                            Client
                        </div>
                        <div>
                            USDA
                        </div>
                    </Col>
                    <Col lg='3' sm='12' className='py-3'>
                        <div className='workBold2'>
                            Role
                        </div>
                        <div>
                            Lead UX Designer
                        </div>
                    </Col>
                    <Col lg='3' sm='12' className='py-3'>
                        <div className='workBold2'>
                            Time
                        </div>
                        <div>
                            01.2024 - 02.2025
                        </div>
                    </Col>
                    <Col lg='3' sm='12' className='py-3'>
                        <div className='workBold2'>
                            Team
                        </div>
                        <div>
                            An agile team of 15
                        </div>
                    </Col>
                </Row>
            </Container>
            <section>
                <Container className='work'>
                    <img alt=''width="100%" src={`/img/${workItem.assets.toLocaleLowerCase()}/cover.jpg`}/>
                    <Container className='work mt-5'>
                        <Row className='py-5'>
                            <Col>
                                <div className='mainTitle'>
                                    35%
                                </div>
                                <div className='mt-3'>
                                    Faster Completion Time
                                </div>
                            </Col>
                            <Col>
                                <div className='mainTitle'>
                                    40%
                                </div>
                                <div className='mt-3'>
                                    Fewer Support Tickets
                                </div>
                            </Col>
                            <Col>
                                <div className='mainTitle'>
                                    90%
                                </div>
                                <div className='mt-3'>
                                    Taks Success Rate
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </section>
            <section>
                <Container className='work py-5'>
                    <img alt=''width="100%" src={`/img/${workItem.assets.toLocaleLowerCase()}/breaker.jpg`}/>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <Row className='text-start py-5' id="problem_statement">
                        <Col className='d-flex align-items-center'>
                            <div>
                                <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/money.jpg`}/>
                            </div>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <div>
                                <span className='workItalic2'>Problem of the Legacy Tool</span>
                                <ul className='workBold'>
                                    <li>
                                        Costly licenses
                                    </li>
                                    <li>
                                        Information silos
                                    </li>
                                    <li>
                                        Requires advanced GIS skills
                                    </li>
                                </ul>
                            </div>
                        </Col>
                        <Col>
                           We redesigned it as the Wetland Digitalization Tool—an embedded, intuitive solution that streamlines workflows, removes technical barriers, and ensures compliant wetland determinations.
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg7'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <Row className='text-start align-items-center py-5'>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/research.jpg`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2' id="research">
                                        Discovery
                                    </div>
                                    <div className='workBold3'>
                                        Reverse-Engineer the Legacy Tool
                                    </div>
                                </div>
                            </div>
                            <div className='pt-3'>
                                We leveraged
                                <span className='workBold'> synthetic users </span>and
                                <span className='workBold'> mapped workflows </span>
                                to uncover dependencies and business logic. The resulting artifact proved essential for onboarding the team and guiding design decisions.
                            </div>
                        </Col>
                        <Col className='text-center'>
                            <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/research2.jpg`}/>
                        </Col>
                    </Row>
                    <div className='text-start'>
                        <div className='workItalic2'>
                            User flow of the legacy tool
                        </div>
                        <div className='pb-5'>
                            <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/ia.jpg`} />
                        </div>
                    </div>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg7'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <Row className='text-start align-items-center py-5'>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/research3.jpg`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2'>
                                        Research
                                    </div>
                                    <div className='workBold3'>
                                        Insight-Led from the Start
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className='pb-3'>
                                We conducted
                                <span className='workBold'> stakeholder interview</span>,
                                <span className='workBold'> user interviews </span>and
                                <span className='workBold'> cognitive walkthroughs</span>,  and identified
                                <span className='workBoldColor7'> key pain points</span>:
                            </div>
                            <ul>
                                <li>
                                    Users rely heavily on manuals and training.
                                </li>
                                <li>
                                    None-GIS experts find ArcGIS Pro overwhelming.
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg7'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work py-5'>
                    <Row className='text-start align-items-center'>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/challenge.jpg`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2' id="challenges">
                                        Design Challenge I
                                    </div>
                                    <div className='workItalic'>
                                        4 Panes {'>'} 2 Panes
                                    </div>
                                    <div className='workBold3'>
                                        Clarity through Structure
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div>
                                A great challenge was transforming the legacy
                                <span className='workBoldColor7'> 4-pane ArcGIS Pro interface</span>, where layers were scattered into a standardized
                                <span className='workBoldColor7'> 2-pane editor window</span>.
                            </div>
                        </Col>
                    </Row>
                    <Row className='pb-5'>
                        <Col className='py-2' lg xs='12'>
                            <div className='workItalic2 text-start'>
                                Legacy 4-Pane UI
                            </div>
                            <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/wct_ui.jpg`} />
                        </Col>
                        <Col className='py-2' lg xs='12'>
                            <div className='workItalic2 text-start'>
                                Desired 2-Pane Editor UI
                            </div>
                            <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/cd_ui.jpg`} />
                        </Col>
                    </Row>
                    <Row className='pb-5 text-start'>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    We used open and closed
                                    <span className='workBold'> card sorting </span>
                                    to understand how users grouped maps and layers, then validated the structure through
                                    <span className='workBold'> tree testing</span>.
                                </div>
                                <div className='px-5'>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/challenge2.jpg`}/>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            The final IA featured 3 primary tabs:
                            <div className='d-flex align-items-center pt-3'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/finger.jpg`}/>
                                </div>
                                <div>
                                    <span className='workBoldItalicColor7'>Feature Layers</span> - Sequential editable layers with built-in validation.
                                </div>
                            </div>
                            <div className='d-flex align-items-center py-3'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/finger.jpg`}/>
                                </div>
                                <div>
                                    <span className='workBoldItalicColor7'>Reference Layers</span> - Non-editable layers for decision-making and context.
                                </div>
                            </div>
                            <div className='d-flex align-items-center pb-3'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/finger.jpg`}/>
                                </div>
                                <div>
                                    <span className='workBoldItalicColor7'>Report Tool</span> - Generates and saves final products to the centralized repository, reducing silos.
                                </div>
                            </div>
                            <div className='d-flex align-items-center'>
                                <div>
                                    Staged and<span className='workBold'> progressive disclosure </span>were applied to support learnability and efficiency.
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className='text-start'>
                        <div className='workItalic2'>
                            Final WDT Information Architecture
                        </div>
                        <div className='pb-5'>
                            <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/wdt_ia.jpg`} />
                        </div>
                    </div>
                    <Row className='text-start'>
                        <Col>
                            <div className='workItalic2'>
                                Feature Layers
                            </div>
                            <div className='wdt_frame'>
                                <div className='wdt_frame_content'>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/feature_layers.jpg`}/>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className='workItalic2'>
                                Reference Layers
                            </div>
                            <div className='wdt_frame'>
                                <div className='wdt_frame_content'>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/reference_layers.jpg`}/>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className='workItalic2'>
                                Report Tools
                            </div>
                            <div className='wdt_frame'>
                                <div className='wdt_frame_content'>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/report_tools.jpg`}/>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg7'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work py-5'>
                   <Row className='text-start align-items-center'>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/challenge.jpg`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2'>
                                        Design Challenge II
                                    </div>
                                    <div className='workItalic'>
                                        WIP Design System
                                    </div>
                                    <div className='workBold3'>
                                        User-First, System-Focused
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div>
                                Another challenge was working with the new, still-evolving design system. As the first team to implement it, we faced both opportunity and friction.
                            </div>
                        </Col>
                    </Row>
                    <div>
                        <div className='workItalic2 text-start'>
                            Final WDT UI (Core)
                        </div>
                        <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/editor_window_ui.jpg`} />
                    </div>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg7'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work py-5'>
                   <Row className='text-start align-items-center'>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/clap.jpg`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2' id="enhancements">
                                        An Enhancement that Received Applause
                                    </div>
                                    <div className='workBold3'>
                                        Gated Validation
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='text-start align-items-center'>
                        <Col>
                            The legacy tool enforced a rigid step-by-step flow, but research showed users often needed to reedit earlier layers. 
                        </Col>
                        <Col lg='6' xs='12'>
                            <img alt='' width="100%" src={`/img/${workItem.assets.toLocaleLowerCase()}/flow1.jpg`}/>
                        </Col>
                    </Row>
                    <Row className='text-start align-items-center py-5'>
                        <Col lg='6' xs='12'>
                            <img alt='' width="100%" src={`/img/${workItem.assets.toLocaleLowerCase()}/flow2.jpg`}/>
                        </Col>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    My first design offered user freedom but created too much dirty data. 
                                </div>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/negative.jpg`}/>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='text-start align-items-center'>
                        <Col>
                            Re-analyzing interviews, I found users only moved within related steps. Partnered with Subject Matter Expert, I introduced layer groups—flexible within a group, gated between groups—
                            <span className='workBoldColor7'>providing user freedom and keep dirty data manageable</span>.
                        </Col>
                        <Col lg='6' xs='12'>
                            <img alt='' width="100%" src={`/img/${workItem.assets.toLocaleLowerCase()}/flow3.jpg`}/>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg7'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <Row className='text-start align-items-center py-5'>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/ai.jpg`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2'>
                                        Another Feature that Received Applause
                                    </div>
                                    <div className='workBold3'>
                                        AI-Assisted Planner
                                    </div>
                                </div>
                            </div>
                            <div>
                                <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/ai1.jpg`}/>
                            </div>
                        </Col>
                        <Col>
                            <div className='pb-3'>
                                The AI tool is integrated into Representative Observation and Reference Point planning. It:
                            </div>
                            <ul className='pb-3'>
                                <li>
                                    Generates optimized points from natural language prompts.
                                </li>
                                <li>
                                    Auto-fills attributes and links to related items across layers.
                                </li>
                                <li>
                                    Supports fast edits, queries, and real-time suggestions.
                                </li>
                            </ul>
                            <div>
                                <span className='workBoldColor7'>This feature ensures geometric accuracy and unlocks efficiency.</span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg7'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <Row className='text-start align-items-center py-5'>
                        <Col>
                            <div className='workItalic2'>
                                The 3rd Feature that Received Applause
                            </div>
                            <div className='workBold3'>
                                Conversion btw Item Types
                            </div>
                            <div>
                                <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/items.jpg`}/>
                            </div>
                        </Col>
                        <Col>
                            <div className='pb-3'>
                               In the legacy system, items that failed validation had to be deleted. I introduced a conditional conversion feature enabling users to switch between item types. 
                            </div>
                            <div>
                                <span className='workBoldColor7'>This enhancement allowed users to preserve the work while maintaining data integrity.</span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg7'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <Row className='text-start align-items-center py-5'>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/pc.jpg`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2' id="validation">
                                        Test & Review
                                    </div>
                                    <div className='workBold3'>
                                        Validating through Simulation
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className='pb-3'>
                                Traditional usability testing wasn't feasible due to the complexity of GIS editing. Alternatively, we adopted expert reviews:
                            </div>
                            <ul className='pb-3'>
                                <li>
                                    Built high-fidelity prototypes covering common paths and edge cases.
                                </li>
                                <li>
                                    Conducted live demos with users and sponsors.
                                </li>
                                <li>
                                    Collected feedback in sessions and follow-up surveys to drive iteration.
                                </li>
                            </ul>
                        </Col>
                    </Row>
                    <Row className='pb-5'>
                        <Col className='py-2' lg xs='12'>
                            <div className='workItalic text-start'>
                                Live prototype feedback session led by me
                            </div>
                            <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/demo1.jpg`} />
                        </Col>
                        <Col className='py-2' lg xs='12'>
                            <div className='workItalic text-start'>
                                Live beta feedback session led by the Dev Lead
                            </div>
                            <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/demo2.jpg`} />
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg7'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <Row className='text-start align-items-center py-5'>
                        <Col>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/impact.png`}/>
                                </div>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div>
                                    <div className='workItalic2' id="impact">
                                        Impact
                                    </div>
                                    <div className='workBold3'>
                                        Clearer, Smarter, Stronger
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className='pb-3'>
                                WDT retained all core legacy functions while enhancing clarity, validation, and navigation, leading to:
                            </div>
                            <ul className='pb-3'>
                                <li>
                                    <span className='workBoldColor7'>35% faster </span>completion time.
                                </li>
                                <li>
                                    <span className='workBoldColor7'>40% fewer </span>support tickets.
                                </li>
                                <li>
                                    Increased <span className='workBoldColor7'> user confidence</span>.
                                </li>
                            </ul>
                            <div>
                                Users and sponsors praised its seamless platform integration, guided workflows, real-time data sync, and info repository collaboration.
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container fluid className='work altbg7 py-5 mt-5'>
                    <Container className='altbg7Font work'>
                        <Row className='text-start align-items-center py-5'>
                            <Col>
                                <div className='d-flex align-items-center'>
                                    <div>
                                        <img alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/think.png`}/>
                                    </div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div>
                                        <div className='workItalic' id="conclusion">
                                            What I Learned
                                        </div>
                                        <div className='workBold3'>
                                            Growing through Complexity<br></br>and Collaboration
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <div className='workBold'>
                                    Architecting complex workflows into clear user journeys
                                </div>
                                <div className='pb-5'>
                                    I deepened my ability to simplify rigid data-heavy, technical workflows into intuitive, flexible user journeys.
                                </div>
                                <div className='workBold'>
                                    Designing with a system that's still evolving
                                </div>
                                <div className='pb-5'>
                                    As the first team to implement the new USDA design system, I created workarounds, contributed missing components, and collaborated cross-functionally to shape scalable patterns for future products.
                                </div>
                                <div className='workBold'>
                                    Practicing design leadership beyond the craft
                                </div>
                                <div>
                                    I encouraged open sharing of diverse perspectives, which often sparked breakthrough ideas during periods of design stagnation.
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </section>
            <Container className='work workFooter'>
                <WorkFooter workPrevious={workItem.workPrevious} workPreviousTitle={workItem.workPreviousTitle} workNext={workItem.workNext} workNextTitle={workItem.workNextTitle} />
            </Container>
            <Context workPrevious={workItem.workPrevious} workNext={workItem.workNext} contextItems={workItem.contextItems} />
        </>
    );
  }